import { render, staticRenderFns } from "./StockPurchaseAll.vue?vue&type=template&id=5d57dbb8&"
import script from "./StockPurchaseAll.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports